export const uuid = () => Math.floor(Math.random() * 100000000).toString(36);
